/**
 * Split pay line shares. The order's grand total is what is owed; each line's
 * share is that total split in proportion to the line's own amount, rounded to
 * the halala with the remainder on the largest fractions, so the shares always
 * add up exactly to the bill. Mirrors payment_service
 * external_clients/order_client._cover_order_total, which prices the charge:
 * the amount a guest sees is the amount they are charged.
 */
export function allocateToTotal(weights: number[], total: number): number[] {
  const totalCents = Math.round(total * 100);
  let w = weights.map((x) => Math.max(0, x || 0));
  let wSum = w.reduce((a, b) => a + b, 0);
  if (wSum <= 0) {
    w = w.map(() => 1);
    wSum = w.length;
  }
  const raw = w.map((x) => (totalCents * x) / wSum);
  const parts = raw.map((r) => Math.floor(r));
  const order = raw
    .map((r, i) => [r - parts[i], i] as const)
    .sort((a, b) => b[0] - a[0]);
  let left = totalCents - parts.reduce((a, b) => a + b, 0);
  for (const [, i] of order) {
    if (left <= 0) break;
    parts[i] += 1;
    left -= 1;
  }
  return parts.map((c) => c / 100);
}
